import { AppContext, isAuthorised } from '@nile/components';
import {
  CellWrapper,
  DisabledTag
} from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Link, Badge } from '@superops/ui-design-system';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
// import { debug } from 'webpack';

function HTMLCell(props) {
  const { cell, action } = props;
  const appContext = useContext(AppContext);
  const { user } = appContext;
  const reference = user?.role?.roleFeatureList || [];
  const isEditAuthorised = isAuthorised(reference, 'script.edit');
  const { isTestExecution = false } = cell?.row?.original;
  const actions = cell.column.actions;
  const value = props.column.subAccessor
    ? cell.value[props.column.subAccessor]
    : cell.value;
  // let allProps;
  // if (cell?.row?.original?.userActionConfig) {
  //   console.log(
  //     'inside iffff ',
  //     cell.row.original.userActionConfig.script.scriptId
  //   );
  //   allProps = {
  //     ...cell,
  //     scriptId: cell.row.original.userActionConfig.script.scriptId,
  //     module: 'SCRIPT_DETAIL',
  //     data: {
  //       scriptId: cell?.row?.original?.userActionConfig?.script?.scriptId,
  //       title: cell?.row?.original?.userActionConfig?.script?.name,
  //       value: cell?.row?.original?.userActionConfig?.script?.name
  //     }
  //   };
  // } else {
  //   console.log('inside elseee');
  //   allProps = {
  //     ...cell,
  //     scriptId: cell.row.original.scriptId,
  //     module: 'SCRIPT_DETAIL',
  //     data: {
  //       scriptId: cell?.row?.original?.scriptId,
  //       title: cell?.row?.original?.name,
  //       value: cell?.row?.original?.name
  //     }
  //   };
  // }
  // console.log('akkkdata::::::', allProps);
  // debugger;
  /* revisit dangerouslySetInnerHTML xss  */
  return value ? (
    <CellWrapper>
      <div className="fx actr g10 nowrap ">
        <Link
          removeUnderline
          // onClick={isEditAuthorised ? actions.onClick.bind(this, allProps) : null}
          onClick={() => {
            actions.onClick(cell.row.original);
          }}
        >
          <div className="ellipsis">{value}</div>
        </Link>{' '}
        {isTestExecution && (
          <Badge>
            <FormattedMessage id="admin.scripts.TestScript" />
          </Badge>
        )}
      </div>
    </CellWrapper>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default HTMLCell;
